import { render } from "./ModalConsulte.vue?vue&type=template&id=6c844908&ts=true"
import script from "./ModalConsulte.vue?vue&type=script&lang=ts"
export * from "./ModalConsulte.vue?vue&type=script&lang=ts"

import "./ModalConsulte.vue?vue&type=style&index=0&id=6c844908&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__